import { switchCustomerAPITokenApi } from '@/api/authApi';
import { isApp } from '@/config/device';
import { store } from '@/config/store';
import { message } from '@/consts/login';
import { url } from '@/consts/url';

// Every entry into customer selection must switch the ID and token together.
// Keep the original login method/phone, including when saving to the native app.
export const switchCustomerAuth = async (customerId: number): Promise<void> => {
  const previousAuth = store.state.authInfo;
  const { data } = await switchCustomerAPITokenApi({
    m_customer_id: customerId,
  });
  if (!data.success || !data.token || data.m_customers?.id !== customerId) {
    throw new Error(
      data.error?.message || data.message || message.DEFAULT_LOGIN_ERROR,
    );
  }
  // A delayed response must not overwrite a newer login/logout or selection.
  if (
    store.state.authInfo.m_customer_id !== previousAuth.m_customer_id ||
    store.state.authInfo.token !== previousAuth.token ||
    !store.state.authInfo.isLogin
  ) {
    throw new Error('ログイン状態が変わりました。再度ログインしてください');
  }
  const token = decodeURI(data.token);
  await store.dispatch('setAuthInfo', {
    authInfo: { m_customer_id: customerId, token, isLogin: true },
  });
  if (isApp) {
    window.location.href = `${url.NATIVE_BASE_URL}/set/login_success?token=${token}&id=${customerId}&type=${store.state.loginInfo.loginType}`;
  }
};
